// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WvutUND37blU2gPT0sQO {
  padding-top: 1rem;
  margin-bottom: 1rem;
}

.dJcaADGhHOUi6RkJdw69 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 10px;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/wysiwyg/admin/src/components/GlossaryTermsModal/components/SearchPanel/SearchPanel.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,SAAS;AACX","sourcesContent":[".wrapper {\n  padding-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.searchContainer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `WvutUND37blU2gPT0sQO`,
	"searchContainer": `dJcaADGhHOUi6RkJdw69`
};
export default ___CSS_LOADER_EXPORT___;
